import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { TrustBadges } from '../components/TrustBadges';
import { EfficiencyBar } from '../components/EfficiencyBar';
import { ServicesGrid } from '../components/ServicesGrid';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { CaseTypes } from '../components/CaseTypes';
import { ProcessTimeline } from '../components/ProcessTimeline';
import { InstructionTracker } from '../components/InstructionTracker';
import { Credentials } from '../components/Credentials';
import { TestimonialsCarousel } from '../components/TestimonialsCarousel';
import { Footer } from '../components/Footer';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
export function LandingPage() {
  useEffect(() => {
    document.title = 'UK Medicolegal Assessment | Court-Ready Medical Reports for Solicitors & Insurers';
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('description', 'Independent medico-legal reports from GMC-registered specialists. 1–3 week turnaround. CPR Part 35 compliant. UK-wide coverage. Trusted by solicitors and insurers.');
    setMeta('robots', 'index, follow');
  }, []);
  return <div className="min-h-screen bg-warm-50 pb-16 lg:pb-0" data-id="element-880">
      <Navigation data-id="element-881" />
      <main data-id="element-882">
        <HeroSection data-id="element-883" />
        <TrustBadges data-id="element-884" />
        <EfficiencyBar data-id="element-885" />
        <ServicesGrid data-id="element-886" />
        <WhyChooseUs data-id="element-887" />
        <ProcessTimeline data-id="element-888" />
        <CaseTypes data-id="element-889" />
        <InstructionTracker data-id="element-890" />
        <Credentials data-id="element-891" />
        <TestimonialsCarousel data-id="element-892" />
      </main>
      <Footer data-id="element-893" />
      <StickyMobileCTA data-id="element-894" />
    </div>;
}